export default __webpack_public_path__ + "static/illustration-content-button.url-c6b9f58c341142fd85d52a0b707a2c95.svg";